import { render, staticRenderFns } from "./ArticleTabs.vue?vue&type=template&id=526903a3&scoped=true&"
import script from "./ArticleTabs.vue?vue&type=script&lang=js&"
export * from "./ArticleTabs.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTabs.vue?vue&type=style&index=0&id=526903a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526903a3",
  null
  
)

export default component.exports